<template>
  <div class="cause-contain">
      <div class="title">{{title}}</div>
      <div class="content">
        <div class="item" v-for="(item,index) in detailList" :key="index">
          <div class="name">{{item.name}}</div>
          <div class="text" :class="item.name=='响应时长'||item.name=='处理时长'?' red':''">{{item.value|filt}}</div>
        </div>
      </div>
  </div>
</template>

<script>
    export default {
        name: 'causeDeduction',
        props: {
            title: String,
            detailList: Array
        },
        data () {
            return {

            }
        },
        mounted () {

        },
        filters:{
          filt(value){
            if(value){
              return value;
            }else{
              return '未响应'
            }
          }
        }
    }
</script>

<style lang="less" scoped>
.cause-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:20px;
    margin-top: 24px;
  }
  .content{
    margin-top:12px;
    padding: 16px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:24px;
    .item{
      display: flex;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      margin-bottom: 9px;
      line-height: 20px;
      .name{
        width: 96px;
        color: #999999;
      }
      .text{
        color: #333333;
        word-break: break-all;
        flex:1;
      }
      .red{
        color: #FF4D4D;
      }
    }
    .item:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
